import { render, staticRenderFns } from "./IMTableHeaderTranslations.vue?vue&type=template&id=7cd77063&scoped=true&"
import script from "./IMTableHeaderTranslations.vue?vue&type=script&lang=js&"
export * from "./IMTableHeaderTranslations.vue?vue&type=script&lang=js&"
import style0 from "./IMTableHeaderTranslations.vue?vue&type=style&index=0&id=7cd77063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd77063",
  null
  
)

export default component.exports